import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function BusinessGis({ getData }) {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    getData(
      "GIS",
      "사람이 살아가는데 필요한 많은 정보를",
      "공간 정보와 결합한 시스템입니다."
    );
    window.addEventListener("scroll", updateScroll);
  }, [getData]);

  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };


  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <div>
          <div className="inner">
            <h2 className="basic-title">GIS 보유 기술</h2>
            <div className="basic-subtitle">
              <p>
                지구상에서 발생하는 시공간의 제반 현상들의 위치정보와 속성정보를
                결합하여
              </p>
              <p>분석을 통해 공간 문제를 해결하고 의사결정을 지원합니다.</p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img gis-img1"></span>
                  <h2 className="technology-name">
                    공간 정보 편집 / 분석 / 가시화
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img2"></span>
                  <h2 className="technology-name">
                    대용량 공간 정보 검수 / 갱신 객체 검출
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img3"></span>
                  <h2 className="technology-name">맞춤형 GIS 시스템 개발</h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      국내 최고 수준 대용량 공간 정보
                    </span>
                    <span className="basic-block">분석 기술 보유</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img5"></span>
                  <h2 className="technology-name">
                    관련 연구 전문 수행인력 보유
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      OGC 국제표준 준수, 시계열 데이터
                    </span>
                    <span className="basic-block">관리 가능</span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div className={ scrollPosition > 1299 ? "basic-banner gis-banner on" : "basic-banner gis-banner"}> 
              <h2 className="basic-banner-title">
              <p className="txt">정보를 공간 정보와</p>
              <p className="txt">결합한 시스템</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">공간 정보 편집시스템</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      eb기반에서 공간데이터 가시화/편집/검수 기능을 지원합니다.
                      
                    </h3>
                    <h3 className="txt">공간데이터 간의 버전 관리가 가능하여 시간별 데이터 관리도
                      가능하며 모든 기능은 OGC 국제표준을 준수합니다.</h3>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      본 시스템은 OpenGDSBuilder2018Prod 오픈소스를 참고하여
                      개발하였으며 해당 라이센스(LGPL)를 따르고 있습니다.
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img gis-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img gis-img2"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">
                  GIS 대용량 데이터 검수/갱신 분석
                </h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      건물, 도로, 지형, 시설물(지하, 지반) 등 대용량 공간 지도
                      파일에서 국내 최고 수준의 고속 검수/갱신 탐지 기술을
                      제공하며 탐지된 객체를
                    </h3>
                    <h3 className="txt">
                      실시간으로 확인 가능한 서비스를 제공합니다.
                    </h3>
                  </div>
                  <ul className="business-cont-list">
                    <li className="business-cont-item">
                      국가기본도, 지하시설물, 지하구조물, 지반 정보 갱신 탐지
                    </li>
                    <li className="business-cont-item">
                      갱신 유형별 탐지 결과 파일 생성
                    </li>
                    <li className="business-cont-item">
                      2D GIS 대용랑 데이터 고속 인덱싱(SHP, DXF 등)
                    </li>
                    <li className="business-cont-item">
                      사용자별 갱신 이력 및 통계 관리
                    </li>
                    <li className="business-cont-item">
                      데이터 갱신 이벤트 감지 및 자동 탐지
                    </li>
                    <li className="business-cont-item">
                      탐지 객체의 갱신 유형에 따른 선택적 스타일 적용
                    </li>
                  </ul>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      지하구조물 및 지반정보 갱신 객체 가시화 도구
                      제작(한국전자통신연구원)
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img gis-img3"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img gis-img4"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <div>
          <div className="inner">
            <h2 className="basic-title">
              <span className="txt">GIS</span>
              <span className="txt">보유 기술</span>
            </h2>
            <div className="basic-subtitle">
              <p>
                지구상에서 발생하는 시공간의 제반 현상들의 위치정보와 속성정보를
                결합하여 분석을 통해 공간 문제를 해결하고 의사결정을 지원합니다.
              </p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img gis-img1"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">공간 정보 편집 / 분</span>
                    <span className="basic-block">석 / 가시화</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img2"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">대용량 공간 정보 검</span>
                    <span className="basic-block">수 / 갱신 객체 검출</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img3"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">맞춤형 GIS 시스템</span>
                    <span className="basic-block">개발</span>{" "}
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">국내 최고 수준 대용</span>
                    <span className="basic-block">량 공간 정보 분석 기</span>
                    <span className="basic-block">술 보유</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img5"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">관련 연구 전문 수행</span>
                    <span className="basic-block">인력 보유</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img gis-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">OGC 국제표준 준</span>
                    <span className="basic-block">수, 시계열 데이터</span>
                    <span className="basic-block">관리 가능</span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div className="basic-banner gis-banner">
            <h2 className="basic-banner-title">
              <p className="txt">정보를 공간 정보와</p>
              <p className="txt">결합한 시스템</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">공간 정보 편집시스템</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      eb기반에서 공간데이터 가시화/편집/검수 기능을 지원합니다.
                      공간데이터 간의 버전 관리가 가능하여 시간별 데이터 관리도
                      가능하며 모든 기능은 OGC 국제표준을 준수합니다.
                    </h3>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img gis-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img gis-img2"></span>
                      </li>
                    </ul>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      본 시스템은 OpenGDSBuilder2018Prod 오픈소스를 참고하여
                      개발하였으며 해당 라이센스(LGPL)를 따르고 있습니다.
                    </li>
                  </ul>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">
                  GIS 대용량 데이터 검수/갱신 분석
                </h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      건물, 도로, 지형, 시설물(지하, 지반) 등 대용량 공간 지도
                      파일에서 국내 최고 수준의 고속 검수/갱신 탐지 기술을
                      제공하며 탐지된 객체를 실시간으로 확인 가능한 서비스를
                      제공합니다.
                    </h3>
                  </div>
                  <ul className="business-cont-list">
                    <li className="business-cont-item">
                      국가기본도, 지하시설물, 지하구조물, 지반 정보 갱신 탐지
                    </li>
                    <li className="business-cont-item">
                      갱신 유형별 탐지 결과 파일 생성
                    </li>
                    <li className="business-cont-item">
                      2D GIS 대용랑 데이터 고속 인덱싱(SHP, DXF 등)
                    </li>
                    <li className="business-cont-item">
                      사용자별 갱신 이력 및 통계 관리
                    </li>
                    <li className="business-cont-item">
                      데이터 갱신 이벤트 감지 및 자동 탐지
                    </li>
                    <li className="business-cont-item">
                      탐지 객체의 갱신 유형에 따른 선택적 스타일 적용
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img gis-img3"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img gis-img4"></span>
                      </li>
                    </ul>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      지하구조물 및 지반정보 갱신 객체 가시화 도구
                      제작(한국전자통신연구원)
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default BusinessGis;
